module.exports = __webpack_public_path__ + "img/kefu2.faebe014.png";